import { ValidationResult } from '../formField/types/form-validator';
import { SelectedTime } from '../../gzTimePicker/types';

export const MaxTimeValidator = (maxTime: SelectedTime, errorMessage: string) => {
  return async (timeValue: SelectedTime): Promise<ValidationResult> => {
    if (!timeValue || !maxTime) {
      return { valid: false, error: errorMessage };
    }

    do {
      if (timeValue.hours < maxTime.hours) {
        break;
      }

      if (timeValue.hours === maxTime.hours && timeValue.minutes < maxTime.minutes) {
        break;
      }

      return { valid: false, error: errorMessage };
    } while (false);

    return { valid: true };
  };
};
